import { adapter } from '@seek/tealium-adapter';
import { memoize } from 'lodash';
import { v4 as uuid } from 'uuid';

import type {
  CreateAnalytics,
  AnalyticsState,
  UpdateAnalyticsState,
  TrackLink,
  TrackView,
  SetPage,
  HubbleEventName,
} from './analytics.types';

// Only use for testing as we want a singleton for the analytics client
export const createAnalytics: CreateAnalytics = () => {
  const analytics = adapter();
  let state: AnalyticsState = {};

  const updateAnalyticsState: UpdateAnalyticsState = (props) => {
    state = {
      ...state,
      ...props,
    };

    return state;
  };

  const setPage: SetPage = (props) => {
    const { pageTitle, currentPage } = props;
    state = {
      ...state,
      pageTitle,
      currentPage,
    };
  };

  // LETS converge onto these 2 functions and remove others
  const trackLink: TrackLink = (props) => {
    const { link, ...restProps } = props;

    analytics.link(link, { ...state, ...restProps });
  };

  const trackView: TrackView = (props) => {
    const { eventName, view, ...restProps } = props;
    analytics.view(eventName, {
      ...state,
      ...restProps,
      page: view,
      pageTitle: view,
      currentPage: view,
      view,
    });
  };

  const trackingCorrelationId = memoize<
    (forHubbleEvent: HubbleEventName) => string
  >((_) => uuid());

  return {
    state,
    updateAnalyticsState,
    setPage,
    trackView,
    trackLink,
    trackingCorrelationId,
  };
};

export const analyticsClient = createAnalytics();
